import { CookieManager, CookieSetOptions } from './types';

export * from './types';

class CookieManagerImpl implements CookieManager {
    set(name: string, value: string, options: CookieSetOptions = {}): void {
        const { path = '/', domain = '.yandex.ru', maxAge, expires, secure, sameSite = 'Lax' } = options;

        const normalizedSameSite = sameSite;
        const shouldSecure = secure ?? normalizedSameSite === 'None';

        let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (typeof maxAge === 'number') {
            cookie += `; Max-Age=${Math.floor(maxAge)}`;
        } else if (expires) {
            const exp = expires instanceof Date ? expires.toUTCString() : String(expires);
            cookie += `; Expires=${exp}`;
        }

        if (path) {
            cookie += `; Path=${path}`;
        }
        if (domain) {
            cookie += `; Domain=${domain}`;
        }
        cookie += `; SameSite=${normalizedSameSite}`;
        if (shouldSecure) {
            cookie += `; Secure`;
        }

        document.cookie = cookie;
    }

    get(name: string): Maybe<string> {
        try {
            const target = encodeURIComponent(name) + '=';
            const parts = document.cookie ? document.cookie.split(/;\s*/) : [];

            for (const part of parts) {
                // part вида 'name=value'
                if (part.startsWith(target)) {
                    const rawValue = part.slice(target.length);
                    return decodeURIComponent(rawValue);
                }
            }
        } catch {
            return;
        }
    }
}

const cookieManager = new CookieManagerImpl();

export default cookieManager;
